(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('SeanceCoursDeleteController',SeanceCoursDeleteController);

    SeanceCoursDeleteController.$inject = ['$uibModalInstance', 'entity', 'SeanceCours'];

    function SeanceCoursDeleteController($uibModalInstance, entity, SeanceCours) {
        var vm = this;

        vm.seanceCours = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SeanceCours.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
